import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

// import styles from './InfoSection.module.css'
import './infoSection.css'

const InfoSection = ({
  infoHeadline,
  infoDescription,
  imgStart,
  infoImgSrc,
  infoImgAlt,
}) => {
  return (
    <>
      <section className='info-section-wrapper'>
        <Container>
          <Row className='d-flex align-items-center'>
            <Col sm={(12, { order: 1 })} lg={(6, { order: 2 })}>
              <div className='infoSection-text-wrapper'>
                <h1>{infoHeadline}</h1>
                <p>{infoDescription}</p>
              </div>
            </Col>
            <Col
              sm={(12, { order: 2 })}
              md={12}
              lg={(6, { order: imgStart ? 1 : 3 })}
              className='text-center'
            >
              <div className='infoSection-img-wrapper'>
                <img src={infoImgSrc} alt={infoImgAlt}></img>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default InfoSection
